'use strict';

var DemandPostingBreakdownModalDirective = function DemandPostingBreakdownModalDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/demand-posting-confirmation-modal.html'),
    controller: 'DemandPostingConfirmationModalController',
    scope: {
      gridParams: '=',
      operations: '=',
      dimension: '=',
      onModalConfirmation: '&'
    },
    link: function link($scope, $element) {
      $scope.closeModal = function () {
        $element.modal('hide');
      };
      $scope.confirmModal = function () {
        $scope.onModalConfirmation();
        $scope.closeModal();
      };
      $scope.$on('demand-posting:open-confirmation-modal', function (event, market) {
        $scope.calculateSummary(market);
        $element.modal('show');
      });
    }
  };
};
DemandPostingBreakdownModalDirective.$inject = [];
module.exports = DemandPostingBreakdownModalDirective;